import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { EventsService, AttendeeTypes} from '../services';

@Injectable()
export class CanActivateOverview {
    constructor(
        private eventsService: EventsService,
        private window: Window
    ) {}

    public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        const { eventId } = route.params;

        return this.eventsService.getEventById(eventId).pipe(
            tap(event => {
                if (event.attendee_type._id === AttendeeTypes.Student) {
                    this.window.location.href = `/events/${event.nickname}/register`;
                }
            }),
            map(response => response.attendee_type._id !== AttendeeTypes.Student),
        );
    }
}